import React, { useEffect, useRef, useState } from "react";
import { overview } from "../mock";

const Counter = ({ target, suffix }) => {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          let start = 0;
          const step = Math.max(1, Math.round(target / 40));
          const t = setInterval(() => {
            start += step;
            if (start >= target) { setVal(target); clearInterval(t); } else setVal(start);
          }, 40);
          io.disconnect();
        }
      });
    }, { threshold: 0.4 });
    io.observe(el);
    return () => io.disconnect();
  }, [target]);
  return <span ref={ref}>{val}{suffix}</span>;
};

const Overview = () => (
  <section id="overview-section" className="relative py-20 md:py-28 overflow-hidden" style={{ backgroundImage: `url(${overview.bg})`, backgroundSize: "cover", backgroundPosition: "center" }}>
    <div className="absolute inset-0 bg-[#f8f2e8]/85" />
    <img src={overview.flower} alt="" className="ornament -left-10 top-20 w-40 opacity-70" />
    <div className="relative max-w-[1120px] mx-auto px-5 lg:px-8 text-center">
      <p className="eyebrow">{overview.eyebrow}</p>
      <div className="divider-leaf my-3" />
      <h2 className="h-title text-[30px] md:text-[46px] mb-6">{overview.title}</h2>
      <p className="text-[15px] md:text-[16px] leading-[1.9] text-[#4a4a44] max-w-[880px] mx-auto">{overview.desc}</p>

      <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6">
        {overview.stats.map((s) => (
          <div key={s.label} className="bg-white/70 backdrop-blur-sm border border-[#c26a4a]/25 rounded-2xl py-8 px-4 card-lift">
            <p className="font-serif-e text-[44px] md:text-[52px] font-semibold text-[#2a3d5c] leading-none">
              <Counter target={s.value} suffix={s.suffix} />
            </p>
            <div className="divider-leaf my-3" />
            <p className="font-display-e text-[12px] tracking-[.2em] text-[#6b6a63]">{s.label}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Overview;
